<template>
  <div class="section-title" :class="{ visible: visible }" ref="titleRef">
    <h2>{{ title }}</h2>
    <p v-if="subtitle">{{ subtitle }}</p>
    <div class="divider"></div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

defineProps({
  title: String,
  subtitle: String
})

const titleRef = ref(null)
const visible = ref(false)

onMounted(() => {
  if (!titleRef.value) return
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        visible.value = true
        observer.unobserve(entry.target)
      }
    })
  }, { threshold: 0.2 })
  observer.observe(titleRef.value)
})
</script>

<style scoped>
.section-title {
  text-align: center;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.6s ease;
  margin-bottom: 3rem;
}
.section-title.visible {
  opacity: 1;
  transform: translateY(0);
}
.section-title h2 {
  font-size: clamp(2rem, 5vw, 2.75rem);
  font-weight: 800;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
  letter-spacing: -0.02em;
}
.section-title p {
  color: #8c7b75;
  font-size: 1.1rem;
  margin: 0;
}
.divider {
  width: 60px;
  height: 4px;
  background: var(--accent);
  margin: 1rem auto 0;
  border-radius: 2px;
}
</style>
